import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import axiosClientHyperWolf from "axiosClient/indexHyperWolf";
import { getQueryString } from "utilities/common";
import { STILO, HYPERWOLF, HEMP } from "utilities/constants";
import axiosClientPromotion from "axiosClient/indexPromotion";

const adminsMode = JSON.parse(localStorage.getItem("adminsMode")) || HEMP;

const baseURLS = {
  [STILO]: axiosClientStilo,
  [HYPERWOLF]: axiosClientHyperWolf,
  [HEMP]: axiosClient,
};

// ——— Promotion backend (REACT_APP_BASE_URL_PROMOTIONS) ———
// Listing: products, categories, brands for rule builder
/** Sent on every promotion rule product listing request; merge with caller filters (caller can override). */
export const defaultPromotionProductListingQuery = {
  status: "active",
};

export async function fetchPromotionPlatformProducts(filters = {}) {
  const query = { ...defaultPromotionProductListingQuery, ...filters };
  return await axiosClientPromotion?.get(
    `/api/v1/admin/listing/product?${getQueryString(query)}`
  );
}

export async function fetchPromotionPlatformCategories(filters) {
  return await axiosClientPromotion?.get(
    `/api/v1/admin/listing/category?${getQueryString(filters)}`
  );
}

export async function fetchPromotionPlatformBrands(filters) {
  return await axiosClientPromotion?.get(
    `/api/v1/admin/listing/brand?${getQueryString(filters)}`
  );
}

// List promotions (promotion backend)
export async function fetchPromotionListingAPI(filters) {
  return await axiosClientPromotion?.get(
    `/api/v1/admin/promotion?${getQueryString(filters)}`
  );
}

export async function getAllPromotionsAPI(filters) {
  return await axiosClientPromotion?.get(
    `/api/v1/admin/promotion?${getQueryString(filters)}`
  );
}

export async function getSinglePromotionAPI(promotionId) {
  return await axiosClientPromotion?.get(
    `/api/v1/admin/promotion/${promotionId}`
  );
}

export async function getPromotionDataAPI(promotionId) {
  return await axiosClientPromotion?.get(
    `/api/v1/admin/promotion/${promotionId}`
  );
}

export async function createPromotionAPI(data) {
  return await axiosClientPromotion?.post(
    `/api/v1/admin/promotion/create`,
    data
  );
}

export async function updatePromotionAPI(data, promotionId) {
  return await axiosClientPromotion?.put(
    `/api/v1/admin/promotion/${promotionId}`,
    data
  );
}

export async function updatePromoAPI(data, promoId) {
  return await axiosClientPromotion?.put(
    `/api/v1/admin/promotion/${promoId}`,
    data
  );
}

export async function createPromoAPI(data) {
  return await axiosClientPromotion?.post(
    `/api/v1/admin/promotion/create`,
    data
  );
}

export async function deletePromotionAPI(promotionId) {
  return await axiosClientPromotion?.delete(
    `/api/v1/admin/promotion/${promotionId}`
  );
}

export async function deletePromoAPI(promotionId) {
  return await axiosClientPromotion?.delete(
    `/api/v1/admin/promotion/${promotionId}`
  );
}

// Cart/product rule types and PDF download: main app (no promotion-backend routes yet)
export async function getPromotionCartRulesByTypeAPI() {
  return await baseURLS[adminsMode]?.get(`/api/v1/admin/cart/rules`);
}

export async function getPromotionProductRulesByTypeAPI() {
  return await baseURLS[adminsMode]?.get(`/api/v1/admin/product/rules`);
}

export async function downloadPromotionAsPdfAPI(promotionId) {
  return await baseURLS[adminsMode]?.get(
    `/api/v1/download/csv/promo/${promotionId}`
  );
}